'use strict';

var NamedNode = require('./named-node');

function Namespace(nsuri) {
  return function (ln) {
    return new NamedNode(nsuri + (ln || ''));
  };
}

module.exports = Namespace;


//////////////////
// WEBPACK FOOTER
// ./~/rdflib/lib/namespace.js
// module id = 73
// module chunks = 0